<template>
    <header class="header-area">
        <div class="navigation fixed-top">
            <div class="container pl-60 pr-60">
                <div class="row">
                    <div class="col-lg-12">
                        <nav class="navbar navbar-expand-lg">
                            <router-link to="/" class="navbar-brand">
                                <img src="/img/transmall-logo.png" alt="Logo" style="width: 150px;">
                            </router-link> <!-- Logo -->

                            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="toggler-icon"></span>
                                <span class="toggler-icon"></span>
                                <span class="toggler-icon"></span>
                            </button> <!-- navbar-toggler -->

                            <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                                <ul class="navbar-nav m-auto">
                                    <li class="nav-item"><router-link to="/" class="page-scroll">Home</router-link></li>
                                    <li class="nav-item"><router-link :to="{name: 'products.categories'}" class="page-scroll">Categories</router-link></li>
                                    <li class="nav-item"><router-link :to="{name: 'shops'}" class="page-scroll">Shops</router-link></li>
                                    <li class="nav-item"><router-link :to="{name: 'about'}" class="page-scroll">About Us</router-link></li>
                                    <li class="nav-item">
                                        <router-link :to="{name: 'contact'}" class="page-scroll">contact</router-link>
                                    </li>
                                    <li class="nav-item" v-if="$auth.check()">
                                        <a class="page-scroll" href="#work"><span>{{$auth.user().name}}</span></a>
                                        <ul class="sub-menu">
                                            <li><router-link :to="{name: 'customer.profile'}">Profile</router-link></li>
                                            <li v-if="this.$auth.check(['customer'])"><router-link to="/my-orders">My Orders</router-link></li>
                                            <li><router-link to="/dashboard" v-if="this.$auth.check(['admin', 'retailer',
                                            'wholesaler', 'rider'])">Dashboard</router-link></li>
                                            <li><a href="" @click.prevent="$auth.logout()">Logout</a></li>
                                        </ul> <!-- sub menu -->
                                    </li>
                                    <li class="nav-item" v-if="!$auth.check()">
                                        <router-link to="/login" class="page-scroll">Login</router-link>
                                    </li>
                                    <li class="nav-item" v-if="!$auth.check()">
                                        <router-link to="/register" class="page-scroll">Register</router-link>
                                    </li>
                                </ul>
                            </div> <!-- navbar collapse -->
                            <div class="navbar-icon">
                                <ul>
                                    <li id="carty"><router-link to="/cart" class="shopping-cart-open" href="#">
                                        <i class="pe-7s-cart"></i>
                                        <span id="cartVal" class="badge badge-light">{{cartItemsCount}}</span>
                                    </router-link></li>
                                </ul>
                            </div>
                        </nav> <!-- navbar -->
                    </div>
                </div> <!-- row -->
            </div> <!-- container -->
        </div> <!-- navigation -->
    </header>
</template>

<script>
    export default {
        name: "Nav",
        computed: {
            cartItemsCount() {
                return this.$store.getters.cartItemCount;
            }
        },

    }
</script>

<style scoped>
    #cartVal{
        background: white;
        color: #222222;
        border-radius: 100%;
        font-weight: 500;
        font-size: 12px;
        position: absolute;
        top: -7px;
        right: -15px;
    }
    #cart:last-child a::before {
        position: absolute;
        content: '3';
        height: 18px;
        width: 18px;
        text-align: center;
        line-height: 18px;
        border-radius: 50%;
        color: #222222;
        background: #fff;
        top: -7px;
        right: -15px;
        font-size: 12px;
        font-weight: 500; }
</style>